import {
  TASKPANE_API_ENDPOINTS,
  getApiAuthCredentials,
  createApiHeaders,
  createApiFetchOptions,
  createApiUrl,
} from "../services/apiConfig";
import logger from "../../logger";

export const fetchAllMetrics = async () => {
  try {
    const { accessToken, orgId, orgUnitId } = await getApiAuthCredentials();
    const url = await createApiUrl(TASKPANE_API_ENDPOINTS.ALL_METRICS);
    const headers = createApiHeaders(accessToken, orgId, orgUnitId);
    const options = createApiFetchOptions("GET", headers);

    const response = await fetch(url, options);

    if (!response.ok) {
      throw new Error(
        "API request failed with status " + response.status + " " + response.statusText
      );
    }

    const data = await response.json();

    if (!data) {
      throw new Error("No data returned from API");
    }

    let metricsArray = [];
    if (Array.isArray(data)) {
      metricsArray = data;
    } else if (data.data && Array.isArray(data.data)) {
      metricsArray = data.data;
    } else if (data.metrics && Array.isArray(data.metrics)) {
      metricsArray = data.metrics;
    } else if (data && typeof data === "object") {
      metricsArray = [data];
    }

    return metricsArray;
  } catch (error) {
    logger.error("Error fetching metrics:", error);
    throw error;
  }
};

export const fetchSelectedMetric = async (metricId) => {
  try {
    const { accessToken, orgId, orgUnitId } = await getApiAuthCredentials();
    const url = await createApiUrl(TASKPANE_API_ENDPOINTS.METRICS_BY_ID, {
      metricId: metricId.trim(),
    });
    const headers = createApiHeaders(accessToken, orgId, orgUnitId);
    const options = createApiFetchOptions("GET", headers);

    const response = await fetch(url, options);

    if (!response.ok) {
      throw new Error(
        "API request failed with status " + response.status + " " + response.statusText
      );
    }

    const result = await response.json();

    if (!result) {
      throw new Error("No data returned from API");
    }

    let metricObject = null;

    if (result && typeof result === "object") {
      if (result.data && typeof result.data === "object" && !Array.isArray(result.data)) {
        metricObject = result.data;
      } else if (result.data && Array.isArray(result.data) && result.data.length > 0) {
        metricObject = result.data[0];
      } else if (Array.isArray(result) && result.length > 0) {
        metricObject = result[0];
      } else if (typeof result === "object" && !Array.isArray(result) && !result.data) {
        metricObject = result;
      }
    }

    if (!metricObject || typeof metricObject !== "object" || Array.isArray(metricObject)) {
      throw new Error("No metric data found in API response");
    }

    return metricObject;
  } catch (error) {
    logger.error("Error fetching selected metric:", error);
    throw error;
  }
};
